import { render, staticRenderFns } from "./AdminPromoElement.vue?vue&type=template&id=5d54dad4&scoped=true"
import script from "./AdminPromoElement.vue?vue&type=script&lang=js"
export * from "./AdminPromoElement.vue?vue&type=script&lang=js"
import style0 from "./AdminPromoElement.vue?vue&type=style&index=0&id=5d54dad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54dad4",
  null
  
)

export default component.exports